import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, Progress, Button } from "@learn-me/ui";
import { Trophy, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { useGamificationSummary } from "../hooks/useGamification";

export function GamificationSummaryCard() {
  const { data: summary, isLoading } = useGamificationSummary();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="animate-pulse space-y-4">
            <div className="h-6 bg-muted rounded w-1/3" />
            <div className="h-4 bg-muted rounded w-full" />
            <div className="flex gap-2">
              <div className="h-12 w-12 bg-muted rounded-full" />
              <div className="h-12 w-12 bg-muted rounded-full" />
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!summary || summary.totalBadges === 0) {
    return null;
  }

  return (
    <Card className="overflow-hidden">
      <CardHeader className="bg-gradient-to-r from-amber-50 to-orange-50 border-b">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Trophy className="h-5 w-5 text-amber-500" />
            <h3 className="font-semibold">Tus Logros</h3>
          </div>
          <Link to="/achievements">
            <Button variant="ghost" size="sm">
              Ver todos <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent className="p-4">
        {/* Progress */}
        <div className="mb-4">
          <div className="flex justify-between text-sm mb-1">
            <span className="text-muted-foreground">Badges obtenidos</span>
            <span className="font-medium">
              {summary.earnedBadges} / {summary.totalBadges}
            </span>
          </div>
          <Progress value={summary.progress} className="h-2" />
        </div>

        {/* Recent badges */}
        {summary.recentBadges.length > 0 && (
          <div>
            <p className="text-sm text-muted-foreground mb-2">
              Badges recientes
            </p>
            <div className="flex gap-2 overflow-x-auto pb-2">
              {summary.recentBadges.map((badge, index) => (
                <motion.div
                  key={badge.id}
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex-shrink-0 flex flex-col items-center"
                >
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center text-xl shadow-md">
                    {badge.icon || "🏆"}
                  </div>
                  <p className="text-xs text-center mt-1 max-w-[60px] truncate">
                    {badge.name}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
